export default __webpack_public_path__ + "static/media/check.3707416b.svg";